import { BALANCE } from '../config/balance';
import type { PlayerStats } from '../core/types';
import { spawnBolt } from './bolts';
import { nearestEnemy } from './target';
import { Cooldown, type WeaponController } from './weapon-controller';
import type { Engine } from './engine';

interface ArrowParams {
  count: number;
  damage: number;
  cd: number;
  speed: number;
  size: number;
}

/** 哨箭：自动锁定最近敌人射出穿透直线箭；进化贯日。 */
export class ArrowController implements WeaponController {
  readonly id = 'arrow';
  owned = false;
  private level = 0;
  private isEvolved = false;
  private cooldown = new Cooldown();

  syncBuild(level: number, evolved: boolean): void {
    this.level = level;
    this.owned = level > 0;
    this.isEvolved = evolved;
    if (!this.owned) this.cooldown.reset();
  }

  private compute(stats: PlayerStats): ArrowParams {
    const w = BALANCE.weapons.arrow;
    const L = this.level;
    let count = 1 + w.addCount.filter((lv) => L >= lv).length;
    let damage = w.dmg * (1 + w.dmgPer * (L - 1));
    const cd = (w.cd * (1 - w.cdPer * (L - 1))) / stats.attackSpeedMul;
    const speed =
      w.boltSpeed * (1 + w.speedPer * (L - 1)) * stats.projectileSpeedMul;
    let size = w.size * (1 + w.sizePer * (L - 1)) * stats.areaMul;
    if (this.isEvolved) {
      const e = BALANCE.evolutions.sun_piercer;
      count += e.countBonus;
      damage *= 1 + e.dmgBonus;
      size *= 1 + e.sizeBonus;
    }
    return { count, damage, cd, speed, size };
  }

  update(engine: Engine, dt: number): void {
    if (!this.owned) return;
    const p = this.compute(engine.player.stats);
    if (!this.cooldown.tick(dt, p.cd)) return;

    const player = engine.player;
    // 自动瞄准最近敌人；无敌人时朝走位方向
    const target = nearestEnemy(engine.enemyPool.all(), player.x, player.y);
    const baseAngle = target
      ? Math.atan2(target.y - player.y, target.x - player.x)
      : Math.atan2(engine.faceY, engine.faceX);
    engine.fx.muzzle(player.x, player.y);
    for (let i = 0; i < p.count; i++) {
      const offset = (i - (p.count - 1) / 2) * 0.12;
      spawnBolt(engine.boltPool, {
        kind: 'arrow',
        x: player.x, y: player.y,
        angle: baseAngle + offset,
        speed: p.speed, damage: p.damage, size: p.size,
        pierce: 999, homing: 0, targetId: -1,
      });
    }
  }
}
